export default __webpack_public_path__ + "static/media/stats-illustration.615b9fa0.svg";